import React, { useEffect, useRef } from 'react';
import { authenticatedIdentity } from '../../_services/apiFetch';
import { Button, Modal } from 'react-bootstrap';
import { useBlocker } from 'react-router-dom';

export function AssetMaintenanceDepartureGuard({ blocked, busy }) {
    const identity = useRef(authenticatedIdentity());
    const shouldBlock = () => blocked && identity.current === authenticatedIdentity();
    const blocker = useBlocker(shouldBlock);

    useEffect(() => {
        const prevent = (event) => {
            if (!blocked || identity.current !== authenticatedIdentity()) return;

            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', prevent);

        return () => window.removeEventListener('beforeunload', prevent);
    }, [blocked]);

    return (
        <Modal show={blocker.state === 'blocked'} onHide={() => blocker.reset?.()}>
            <Modal.Header closeButton>
                <Modal.Title>Unsaved maintenance work</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {busy
                    ? 'Wait for the current save or evidence upload before leaving.'
                    : 'Discard local changes and failed photo attempts? Uploaded evidence remains saved.'}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => blocker.reset()}>
                    Keep working
                </Button>
                <Button variant="danger" disabled={busy} onClick={() => blocker.proceed()}>
                    Discard and leave
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
